import React, { useState, useEffect } from 'react';
import { Radio, Button } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
const impactColorAttributesConfig = [
  { label: 'None', key: 'None' },
  { label: 'Frequency & direction (binned)', key: 'frequencyAndDirectionBinned' },
  { label: 'What is the type of impact?', key: 'typeOfImpact' },
  { label: 'Whose P&L does this impact?', key: 'whosePandL' },
  {
    label: 'Actual impact update check (for last completed and previous periods)',
    key: 'actualImpactUpdateCheck',
  },
  { label: 'Total', key: 'total', group: 'Other' },
  { label: 'Impact type (A/F)', key: 'impactType', group: 'Other' },
];
const ImpactColorContent = ({ colorByAttribute, setColorByAttribute }) => {
  const [isClearVisible, setIsClearVisible] = useState(false);

  const handleClear = () => {
    setColorByAttribute('None');
  };

  useEffect(() => {
    setIsClearVisible(colorByAttribute !== 'None' && colorByAttribute !== null);
  }, [colorByAttribute]);
  const groupedAttributes = {};
  impactColorAttributesConfig.forEach((attr) => {
    if (attr.group) {
      if (!groupedAttributes[attr.group]) {
        groupedAttributes[attr.group] = [];
      }
      groupedAttributes[attr.group].push(attr);
    } else {
      if (!groupedAttributes['']) {
        groupedAttributes[''] = [];
      }
      groupedAttributes[''].push(attr);
    }
  });
  return (
    <div style={{ padding: '10px', maxHeight: '500px', overflowY: 'auto' }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
        {isClearVisible && (
          <Button
            type="text"
            onClick={handleClear}
            style={{ padding: 0, color: 'blue' }}
            icon={<CloseCircleOutlined />}
          >
            Clear
          </Button>
        )}
      </div>
      <Radio.Group value={colorByAttribute} onChange={(e) => setColorByAttribute(e.target.value)}>
        {Object.entries(groupedAttributes).map(([groupName, attributes]) => (
          <div key={groupName}>
            {groupName && (
              <div style={{ fontWeight: 'bold', marginTop: '10px', fontSize: 14, color: '#333' }}>
                {groupName}
              </div>
            )}
            {attributes.map((attribute) => (
              <div key={attribute.key} style={{ marginBottom: '0' }}>
                <Radio value={attribute.key} style={{ display: 'block' }}>
                  {attribute.label}
                </Radio>
              </div>
            ))}
          </div>
        ))}
      </Radio.Group>
      {colorByAttribute && colorByAttribute !== 'None' && (
        <div style={{ marginTop: '10px' }}>
          {/* Add color customization options here */}
          <p>Customization options for '{colorByAttribute}' will go here.</p>
          {/* Example: if coloring by 'typeOfImpact', you might have options to set colors for each type */}
        </div>
      )}
    </div>
  );
};

export default ImpactColorContent;
